import React from 'react';
import { DConfirmationModal } from '../../../../../dum';
import { useDeleteExpensesMutation } from '../../../../../../services';

interface IDeleteExpensesProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    expenseId: number | null;
}

export function SDeleteExpenseDialog({
    open,
    setOpen,
    expenseId,
}: IDeleteExpensesProps) {
    const [deleteMutation] = useDeleteExpensesMutation();

    return (
        <DConfirmationModal
            open={open}
            setOpen={setOpen}
            callback={async () => {
                if (expenseId) {
                    try {
                        await deleteMutation({
                            variables: {
                                ExpenseId: expenseId,
                            },
                        });
                        setOpen(false);
                    } catch (e) {
                        console.error(e);
                    }
                }
            }}
        />
    );
}
